import { NewsLetter } from "../../components/newsLetter";
import { ProposteRataGrid } from "../../components/proposteRata";
import { RoundedInfo } from "../../components/roundedInfo";

export function AllOffers() {
  return (
    <>
      <ProposteRataGrid title='ALCUNE OFFERTE DI ESEMPIO AD ANTICIPO ZERO' />
      <NewsLetter />
      <RoundedInfo id='2XKs2NYcToqGFcpTB9U3Yz' center></RoundedInfo>
    </>
  );
}
